// extracted by mini-css-extract-plugin
export var fadeNavBar = "projet-module--fadeNavBar--am9Hh";
export var fadeinFlip = "projet-module--fadeinFlip--ArL5i";
export var fadeinFlop = "projet-module--fadeinFlop--HFz7y";
export var fadeinNavBar = "projet-module--fadeinNavBar--Sia6T";
export var opening = "projet-module--opening--oYGPs";
export var slideBtn = "projet-module--slide-btn--QPYIq";
export var sloganText = "projet-module--slogan-text--QY9zm";